export default "__VITE_ASSET__d1efbc60__"